<template>
  <div class="">
    <el-card class="box-card">
      <div slot="header" class="flex-be">
        <div class="search_condition">
          <el-date-picker
            class="m-r-10"
            size="small"
            v-model="dateTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeTime">
          </el-date-picker>
        </div>
      </div>
      <div class="w-100 content_table">

        <div class="watchList_box isFlex">
          <div class="watch_item_all_box p-10 isFlex" v-for="(item,index) in tableData" :key="index">
            <div class="w-100 watch_item_box p-5">
              <div class="watch_title_bg w-100 flex-be">
                <div>
                  <el-checkbox style="margin: 0 20px;" v-model="item.checked"></el-checkbox>
                  <b class="m-r-20 text-cursor" @click="goToShop(item,'company')">{{item.shopName}}</b>
                </div>
                <span class="m-r-20">{{item.createTime}}</span>
              </div>

              <div class="watch_main_box">
                <div class="h-100 isFlex">
                  <div class="watch_main_item_box" v-for="(o,i) in item.goodsRecommendListVOList" :key="i">
                    <el-image class="flexCenter"
                              style="width: 100px;height: 100px;display: flex;align-items: center;justify-content: center;margin: auto;"
                              :src="o.goodsThumbnail"
                              :preview-src-list="o.goodsThumbnail?[o.goodsThumbnail]:[]">
                      <div slot="error" class="image-slot">
                        暂无图片
                      </div>
                    </el-image>
                    <div class="price_num_comm">¥ {{o.goodsPrice | NumFormat}}</div>
                    <div class="goodsName_box of-2 text-cursor" @click="goToShop(item,'shop')">{{o.goodsName}}</div>
                  </div>
                  <div class="flex-cen w-100 h-px-150" v-if="item.goodsRecommendListVOList.length<=0">暂无商品</div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <el-empty v-if="tableData.length<=0" description="暂无数据"></el-empty>
        <div class="flex-be m-t-20">
          <el-button size="small" type="primary" @click="cancelFollow">批量取消关注</el-button>
          <el-pagination
            @current-change="getDataFn"
            @size-change="handleSizeChange"
            :current-page.sync="current"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :page-sizes="[10,15,20]"
            :page-size="pageSize"
            :total="total"
          ></el-pagination>
        </div>

      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: "watchList",
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      // 这里存放数据
      return {
        dateTime: '',
        tableData: [],
        current: 1, // 当前页码
        total: 10, // 数据总条数
        pageSize: 10,
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      // 获取数据
      this.getDataFn();
    },
    // 方法集合
    methods: {
      changeTime() {
        this.current = 1;
        this.getDataFn();
      },
      async getDataFn() {
        let params = {
          startTime: this.dateTime ? this.dateTime[0] : '',
          endTime: this.dateTime ? this.dateTime[1] : '',
          pageNum: this.current,
          pageSize: this.pageSize,
          shopId: '',
        };
        try {
          let res = await this.$http.post(this.$const.personalCenter.getFocus, params);
          if (res && res.code === 200) {
            // console.log(res);
            res.data.list.forEach((item) => {
              item.checked = false;
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        } catch (e) {
          // console.log(e);
        }
      },
      handleSizeChange(val) {
        this.configTable.pageSize = val;
        this.getDataFn();
      },
      cancelFollow() {
        const data = this.tableData.filter((item) => {
          return item.checked
        });
        if (data.length <= 0) {
          this.$message.warning(this.$PubText.multipleTip);
          return;
        }
        const ids = data.map((item) => {
          return item.id
        });
        let p = {
          focusId: ids.toString()
        };
        this.$confirm('确定取消该关注?', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              let res = await this.$http.delete(this.$const.personalCenter.deleteByFocusId, p);
              if (res && res.code === 200) {
                // console.log(res);
                await this.$message.success(this.$PubText.successCom);
                await this.getDataFn();
              }
            } catch (e) {
              // console.log(e);
            }
          })
          .catch(() => {
          });
        // console.log(data);
      },
      // 去店铺页面
      goToShop(data, type) {
        // console.log(data);
        if (data && data.goodsRecommendListVOList.length > 0) {
          let goodsId = data.goodsRecommendListVOList[0].goodsId;
          if (type === 'company') {
            this.$router.push({path: "/companyInfo", query: {goodsId: goodsId}});
          } else if (type === 'shop') {
            this.$router.push({path: "/shopGoodsList", query: {goodsId: goodsId}});
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .watchList_box {
    flex-wrap: wrap;

    .watch_item_all_box {
      width: 50%;

      .watch_item_box {
        border: 1px solid #dadada;

        .watch_title_bg {
          height: 40px;
          line-height: 40px;
          background: #f5f7fa;
        }
      }

      .watch_main_box {
        width: 100%;
        overflow-x: auto;

        &::-webkit-scrollbar {
          height: 5px;
        }

        .watch_main_item_box {
          width: 135px;
          margin: 5px;
          text-align: center;
          flex: none;

          .goodsName_box {
            &:hover {
              color: #1890ff;
            }
          }
        }
      }
    }
  }
</style>
